import React from 'react';
import './public/site.css';
import PublicHeader from './public/PublicHeader';
import PublicFooter from './public/PublicFooter';

const ContactEN: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Contact - Fconnect';
  }, []);
  return (
    <div className="home-page fc-site">
      <PublicHeader lang="en" />

      {/* Content */}
      <section className="home-container">
        <header className="contact-header">
          <h1>Contact us</h1>
          <p className="header-subtitle">We are always ready to help</p>
        </header>
        <div className="contact-content">
          <section className="contact-section">
            <h2>Contact information</h2>
            <div className="contact-info-grid">
              <div className="contact-card">
                <div className="contact-icon">
                  <span>📧</span>
                </div>
                <h3>Email</h3>
                <p><strong>trile@fconnect.vn</strong></p>
                <p>Respond within 2–4 business hours</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📞</span>
                </div>
                <h3>Phone</h3>
                <p><strong>02513684266</strong></p>
                <p>Live support 8:00 - 22:00</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📍</span>
                </div>
                <h3>Address</h3>
                <p><strong>HIEP TIN PHAT FINANCE JOINT STOCK COMPANY</strong></p>
                <p><strong>11/4C, To 15, Kp 6, Nguyen Ai Quoc Street</strong></p>
                <p>Tran Bien Ward</p>
                <p>Dong Nai City, Vietnam</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>🕐</span>
                </div>
                <h3>Working hours</h3>
                <p><strong>Monday - Sunday</strong></p>
                <p>8:00 - 22:00</p>
                <p>Customer support 24/7</p>
              </div>
            </div>
          </section>
        </div>
      </section>

      <PublicFooter lang="en" />
    </div>
  );
};

export default ContactEN;


